import {
  alpha,
  Badge,
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  InputBase,
  OutlinedInput,
  Paper,
  Stack,
  styled,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../../firebaseConfig";
import {
  generateAllProductsColumns,
  generateNewProductsColumns,
  generateUnderReviewProductsColumns,
  generateVariantColumns,
} from "../helper";
import { toast } from "react-toastify";
import StoreStepperContext from "../../../context/storeStepperContext";
import { useNavigate } from "react-router-dom";
import ActiveProductData from "./ActiveProductData";
import NewProductData from "./NewProductData";
import UnderReviewData from "./UnderReviewData";
import SimpleBar from "simplebar-react";
import close from "../../../assets/svg/closeicon.svg";
import warning from "../../../assets/svg/warning.svg";
import right from "../../../assets/svg/whiteRight.svg";
import cancel from "../../../assets/svg/whiteCancel.svg";
import DataTableComponent from "../../../components/common/DataTable/DataTable";
import ConfirmationModal from "../../../components/common/ConfirmationModal/ConfirmationModal";
import { getDownloadURL, ref } from "firebase/storage";
import Loader from "../../../assets/images/abc2.gif";
import { useSelector } from "react-redux";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  height: "40px",
  border: "1px solid #EEEEEE",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "230px",
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ minHeight: "73vh", maxHeight: "73vh" }}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default function ProductList() {
  const [searchValue, setSearchValue] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [activeProducts, setActiveProducts] = useState([]);
  const [newProducts, setNewProducts] = useState([]);
  const [underReviewProducts, setUnderReviewProducts] = useState([]);
  const [value, setValue] = useState(0);
  const [underReviewDrawer, setUnderReviewDrawer] = useState(false);
  const [currentData, setCurrentData] = useState();
  const [varinatDatav1, setVariantDatav1] = useState([]);
  const [varinatDatav2, setVariantDatav2] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [confirmatioModalState, setConfirmationModalState] = useState({
    showModal: false,
    productId: "",
  });
  const {
    setAddProductForMasterList,
    editProductForMasterList,
    setEditProductForMasterList,
    setCheckForEdit,
    setProductIdForEdit,
    setAddProductFromOverview,
    setAddProductFromOverviewDocId,
    setProductCatalog,
    setStoreFormData,
  } = useContext(StoreStepperContext);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.value);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchMasterProducts = async () => {
      setLoading(true);
      try {
        const masterListRef = collection(db, "productMasterList");
        const masterListSnapshot = await getDocs(masterListRef);

        const products = await Promise.all(
          masterListSnapshot.docs.map(async (doc) => {
            const data = doc.data();
            let updatedImageUrls = [];

            // Ensure productImage is processed as an array
            const imagePaths = Array.isArray(data.productImage)
              ? data.productImage
              : [data.productImage].filter(Boolean); // Wrap single image in an array

            if (imagePaths.length > 0) {
              try {
                updatedImageUrls = await Promise.all(
                  imagePaths.map(async (imagePath) => {
                    try {
                      const imageRef = ref(storage, imagePath);
                      return await getDownloadURL(imageRef);
                    } catch (error) {
                      console.error(
                        "Error fetching image URL for product:",
                        data.productName,
                        imagePath,
                        error
                      );
                      return imagePath; // Return the original path if URL fetching fails
                    }
                  })
                );
              } catch (error) {
                console.error("Error processing product images:", error);
              }
            }

            return {
              id: doc.id,
              ...data,
              productImage:
                updatedImageUrls.length > 0
                  ? updatedImageUrls
                  : data.productImage, // Update productImage with new URLs or retain original paths
            };
          })
        );
        setAllProducts(products);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching master product list:", error);
      }
    };

    fetchMasterProducts();
  }, [refresh]);

  useEffect(() => {
    if (allProducts) {
      const active = allProducts.filter(
        (product) =>
          (product.productStatus === true &&
            product.productUnderReview === false) ||
          product.productUnderReview === true
      );
      const newProduct = allProducts.filter(
        (product) =>
          product.productStatus === false &&
          product.productUnderReview === false
      );
      const underReviewProduct = allProducts.filter(
        (product) => product.productUnderReview === true
      );

      setActiveProducts(active);
      setNewProducts(newProduct);
      setUnderReviewProducts(underReviewProduct);
    }
  }, [allProducts]);

  const handleChangeStatus = async (productId, newStatus) => {
    try {
      const productRef = doc(db, "productMasterList", productId);

      // Update Firestore document with the new status
      await updateDoc(productRef, {
        productStatus: newStatus,
        productUnderReview: false,
      });

      // Update the UI state to reflect the new status
      setAllProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.id === productId
            ? {
                ...product,
                productStatus: newStatus,
                productUnderReview: false,
              }
            : product
        )
      );

      // Find and update the status in the `stores` collection
      const storesCollection = collection(db, "stores");
      const storesSnapshot = await getDocs(storesCollection);

      for (const storeDoc of storesSnapshot.docs) {
        const storeData = storeDoc.data();

        if (storeData.products && Array.isArray(storeData.products)) {
          // Check if the product exists in the store's products
          const updatedProducts = storeData.products.map((product) =>
            product.productId === productId
              ? {
                  ...product,
                  productStatus: newStatus,
                  productUnderReview: false,
                }
              : product
          );

          // Update the store document if the product is found
          if (
            updatedProducts.some((product) => product.productId === productId)
          ) {
            await updateDoc(doc(db, "stores", storeDoc.id), {
              products: updatedProducts,
            });
          }
        }
      }

      toast.success("Product status changed successfully");
    } catch (error) {
      console.error("Error updating product status:", error);
    }
  };

  const menuOptions = useMemo(
    () => [
      // {
      //   id: "approve",
      //   iconName: "mdi:square-edit-outline",
      //   actionName: "Approve",
      //   onClickHandle: (row) => {
      //     handleChangeStatus(row?.productId, true);
      //     // navigate("/shopping/store/edit", {
      //     //   state: { id: row?.id },
      //     // });
      //   },
      // },
      // {
      //   id: "disapprove",
      //   iconName: "material-symbols:delete-rounded",
      //   actionName: "DisApprove",
      //   onClickHandle: (row) => {
      //     handleChangeStatus(row?.productId, false);
      //     // setConfirmationModalState((prev) => ({
      //     //   showModal: true,
      //     //   storeId: row?.id,
      //     // }));
      //   },
      // },
      {
        id: "edit",
        iconName: "mdi:square-edit-outline",
        actionName: "Edit",
        onClickHandle: (row) => {
          setCheckForEdit(true);
          setProductIdForEdit(row?.productId);
          setAddProductFromOverview(false);
          setProductCatalog(true);
          navigate("/shopping/store/add-product", {
            state: { id: row?.productId },
          });
          // navigate("/shopping/store/add-product-catalog");
        },
      },
    ],
    []
  );

  const allProductColumns = generateAllProductsColumns(menuOptions);

  const handleViewForNew = (row) => {
    setCurrentData(row);
    setUnderReviewDrawer(true);
  };

  const handleRightForNew = async (row) => {
    try {
      const productId = row.productId;
      const productDocRef = doc(db, "productMasterList", productId);
      const productDocSnap = await getDoc(productDocRef);

      if (productDocSnap.exists()) {
        await updateDoc(productDocRef, {
          // productStatus: true,
          productUnderReview: true,
        });
      } else {
        return;
      }

      const storesCollectionRef = collection(db, "stores");
      const storesSnapshot = await getDocs(storesCollectionRef);

      for (const storeDoc of storesSnapshot.docs) {
        const storeData = storeDoc.data();
        const updatedProducts = storeData.products.map((product) => {
          if (product.productId === productId) {
            return {
              ...product,
              // productStatus: true,
              productUnderReview: true,
            };
          }
          return product;
        });

        if (
          JSON.stringify(storeData.products) !== JSON.stringify(updatedProducts)
        ) {
          await updateDoc(doc(db, "stores", storeDoc.id), {
            products: updatedProducts,
          });
        }
      }
      setRefresh(!refresh);
      setValue(2);
    } catch (error) {
      console.error("Error updating product status:", error);
    }
  };

  const handleCancelForNew = (row) => {
    console.log("new Cancel clicked for:");
  };
  const newProductColumns = generateNewProductsColumns({
    onView: handleViewForNew,
    onRight: handleRightForNew,
    onCancel: handleCancelForNew,
  });

  const handleViewForUpdate = (row) => {
    setCurrentData(row);
    setUnderReviewDrawer(true);
  };

  const handleRightForUpdate = async (row) => {
    console.log("new Approve clicked for:");
    try {
      const productId = row.productId;
      const productDocRef = doc(db, "productMasterList", productId);
      const productDocSnap = await getDoc(productDocRef);

      if (productDocSnap.exists()) {
        await updateDoc(productDocRef, {
          productStatus: true,
          productUnderReview: false,
        });
      } else {
        return;
      }

      const storesCollectionRef = collection(db, "stores");
      const storesSnapshot = await getDocs(storesCollectionRef);

      for (const storeDoc of storesSnapshot.docs) {
        const storeData = storeDoc.data();
        const updatedProducts = storeData.products.map((product) => {
          if (product.productId === productId) {
            return {
              ...product,
              productStatus: true,
              productUnderReview: false,
            };
          }
          return product;
        });

        if (
          JSON.stringify(storeData.products) !== JSON.stringify(updatedProducts)
        ) {
          await updateDoc(doc(db, "stores", storeDoc.id), {
            products: updatedProducts,
          });
        }
      }
      setRefresh(!refresh);
      setValue(0);
    } catch (error) {
      console.error("Error updating product status:", error);
    }
  };

  const handleCancelForUpdate = (row) => {
    console.log("Cancel clicked for:");
  };

  const reviewProductColumns = generateUnderReviewProductsColumns({
    onView: handleViewForUpdate,
    onRight: handleRightForUpdate,
    onCancel: handleCancelForUpdate,
  });

  const filteredRowsActive = useMemo(() => {
    return activeProducts?.filter(
      (row) =>
        row?.productName?.toLowerCase()?.includes(searchValue?.toLowerCase()) ||
        row?.parcelName?.toLowerCase()?.includes(searchValue?.toLowerCase())
    );
  }, [activeProducts, searchValue]);

  const filteredRowsNew = useMemo(() => {
    return newProducts?.filter(
      (row) =>
        row?.productName?.toLowerCase()?.includes(searchValue?.toLowerCase()) ||
        row?.parcelName?.toLowerCase()?.includes(searchValue?.toLowerCase())
    );
  }, [newProducts, searchValue]);

  const filteredRowsUnderReview = useMemo(() => {
    return underReviewProducts?.filter(
      (row) =>
        row?.productName?.toLowerCase()?.includes(searchValue?.toLowerCase()) ||
        row?.parcelName?.toLowerCase()?.includes(searchValue?.toLowerCase())
    );
  }, [underReviewProducts, searchValue]);

  useEffect(() => {
    if (currentData) {
      const tableData = currentData?.productVarient?.reduce(
        (acc, variant) => {
          if (variant.variantName === "size") {
            acc.sizes = variant.variantValue; // Collect all sizes
          } else if (variant.variantName === "color") {
            acc.colors = variant.variantValue; // Collect all colors
          }
          return acc;
        },
        { sizes: [], colors: [] } // Initialize sizes and colors arrays
      );

      // Generate combinations of sizes and colors
      const combinedTableData = tableData?.sizes?.flatMap((size) => {
        return tableData.colors.map((color) => ({
          id: `size-${size}-color-${color}`,
          customsize: size,
          customcolor: color,
          price: currentData?.productPrice,
          stock: currentData?.productStock,
          weight: currentData?.productWeight,
          dimensions: `${currentData?.productDimentionL}x${currentData?.productDimentionW}x${currentData?.productDimentionH}`,
        }));
      });

      const tableData2 = currentData?.productVarient?.flatMap((variant) => {
        if (variant.variantName === "size" || variant.variantName === "color") {
          return variant.variantValue.map((value) => ({
            id: `${variant.variantName}-${value}`,
            customsize: variant.variantName === "size" ? value : "",
            customcolor: variant.variantName === "color" ? value : "",
            price: currentData.productPrice,
            stock: currentData.productStock,
            weight: currentData.productWeight,
            dimensions: `${currentData.productDimentionL}x${currentData.productDimentionW}x${currentData.productDimentionH}`,
          }));
        }
        return [];
      });

      setVariantDatav1(combinedTableData);
      setVariantDatav2(tableData2);
    }
  }, [currentData, underReviewDrawer]);

  const variantColumns = generateVariantColumns();
  const cancelHandler = () => {
    setConfirmationModalState({ showModal: false, productId: "" });
  };
  const deleteHandler = async () => {
    setConfirmationModalState({ showModal: false, productId: "" });
    // setLoading(true); // Indicate loading state
    // try {
    //   const storeDocRef = doc(db, "stores", confirmatioModalState.storeId); // Reference the document to delete
    //   await deleteDoc(storeDocRef); // Delete the document
    //   toast.success("Store Deleted Successfully");
    // } catch (error) {
    //   console.error("Error deleting store:", error); // Log any errors
    //   toast.error("Failed to delete store. Please try again.");
    // } finally {
    //   setLoading(false); // Reset loading state
    //   setConfirmationModalState({ showModal: false, storeId: "" }); // Close confirmation modal
    // }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            p: "24px 16px",
            paddingLeft: "0px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Search>
          <Tooltip
            title={
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "6px",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <Badge
                    // color="primary"
                    variant="dot"
                    mr={1}
                    sx={{
                      "& .MuiBadge-badge": {
                        color: "lightgreen",
                        backgroundColor: "blue",
                      },
                    }}
                  />{" "}
                  Parcel Product{" "}
                </span>
              </span>
            }
            arrow
            placement="bottom"
          >
            <ErrorOutlineIcon />
          </Tooltip>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#5E17EB",
              color: "#fff",
              marginLeft: "20px",
              borderRadius: "4px",
              fontWeight: 600,
              marginTop: "20px",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#5E17EB",
              },
            }}
            onClick={() => {
              setAddProductForMasterList(true);
              navigate("/shopping/store/add-product");
              setCheckForEdit(false);
              setProductIdForEdit("");
              setAddProductFromOverview(false);
              setProductCatalog(false);
              setStoreFormData((prev) => ({
                ...prev,
                currentProduct: {
                  productId: "",
                  productName: "",
                  productCategory: "",
                  productBrand: "",
                  productPrice: "",
                  productWeight: "",
                  productStock: "",
                  productDimentionL: "",
                  productDimentionW: "",
                  productDimentionH: "",
                  productDescription: "",
                  productTags: [],
                  productImage: [],
                  productVarient: [],
                  productStatus: user?.role === "Superadmin" ? true : false,
                  productUnderReview: false,
                },
              }));
            }}
          >
            Add Product
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          border: "1px solid rgba(229, 229, 232, 1)",
          borderRadius: "4px",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="product catalog tabs"
          sx={{ height: "auto", minHeight: "auto !important" }}
        >
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                    Active
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      marginLeft: 1,
                      backgroundColor:
                        value === 0
                          ? "rgba(225, 209, 255, 1)"
                          : "rgba(229, 229, 232, 1)",
                      fontWeight: 700,
                      fontSize: "12px",
                      padding: "4px",
                      borderRadius: "6px",
                    }}
                  >
                    {activeProducts?.length}
                  </Typography>
                </Box>
              </Box>
            }
            sx={{
              paddingBottom: "6px",
              height: "auto",
              minHeight: "auto !important",
              fontSize: "14px",
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                    New
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      marginLeft: 1,
                      backgroundColor:
                        value === 1
                          ? "rgba(225, 209, 255, 1)"
                          : "rgba(229, 229, 232, 1)",
                      fontWeight: 700,
                      fontSize: "12px",
                      padding: "4px",
                      borderRadius: "6px",
                    }}
                  >
                    {newProducts?.length}
                  </Typography>
                </Box>
              </Box>
            }
            sx={{
              paddingBottom: "6px",
              height: "auto",
              minHeight: "auto !important",
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                    Under Review
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      marginLeft: 1,
                      backgroundColor:
                        value === 2
                          ? "rgba(225, 209, 255, 1)"
                          : "rgba(229, 229, 232, 1)",
                      fontWeight: 700,
                      fontSize: "12px",
                      padding: "4px",
                      borderRadius: "6px",
                    }}
                  >
                    {underReviewProducts?.length}
                  </Typography>
                </Box>
              </Box>
            }
            sx={{
              paddingBottom: "6px",
              height: "auto",
              minHeight: "auto !important",
            }}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center", marginTop: 10 }}
            >
              <img src={Loader} style={{ height: "80px" }} alt="loader" />
            </Box>
          ) : (
            <ActiveProductData
              filteredRows={filteredRowsActive}
              allProductColumns={allProductColumns}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center", marginTop: 10 }}
            >
              <img src={Loader} style={{ height: "80px" }} alt="loader" />
            </Box>
          ) : (
            <NewProductData
              filteredRows={filteredRowsNew}
              newProductColumns={newProductColumns}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center", marginTop: 10 }}
            >
              <img src={Loader} style={{ height: "80px" }} alt="loader" />
            </Box>
          ) : (
            <UnderReviewData
              filteredRows={filteredRowsUnderReview}
              newProductColumns={reviewProductColumns}
            />
          )}
        </TabPanel>
      </Box>
      <Drawer
        variant="temporary"
        anchor="right"
        open={underReviewDrawer}
        onClose={() => {
          setCurrentData();
          setUnderReviewDrawer(false);
        }}
        BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
      >
        <Box sx={{ width: "50vw" }}>
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "24px", fontWeight: 700 }}>
              {value === 1 ? `New Product` : `Review Product`}
            </Typography>
            <Box
              sx={{ paddingRight: "30px", cursor: "pointer" }}
              onClick={() => {
                setCurrentData();
                setUnderReviewDrawer(false);
              }}
            >
              <img src={close} alt="close" />
            </Box>
          </Box>
          <Box
            sx={{
              minHeight: "84vh",
              borderBottom: "1px solid rgba(229, 229, 232, 1)",
            }}
          >
            <SimpleBar
              forceVisible="x"
              autoHide={true}
              style={{
                overflowX: "hidden",
                maxHeight: "84vh",
              }}
              className="custom-scrollbar"
            >
              <Box
                sx={{
                  padding: "20px",
                  backgroundColor: "white",
                }}
              >
                <Box
                  sx={{
                    marginBottom: "24px",
                    height: "45px",
                    border: "1px solid rgba(242, 153, 74, 1)",
                    backgroundColor: "rgba(251, 222, 197, 1)",
                    display: "flex",
                    alignItems: "center",
                    paddingX: 2,
                    borderRadius: "4px",
                  }}
                >
                  <img src={warning} alt="warning" width="24px" height="24px" />
                  <Typography sx={{ fontSize: "14px", marginLeft: 1 }}>
                    Please view product before you Approve or Decline the
                    product
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Name
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Name"
                        readOnly
                        name="productName"
                        value={currentData?.productName || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Stack direction="row" sx={{ marginTop: "20px" }} gap={2}>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Category
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Category"
                        readOnly
                        name="productCategory"
                        value={currentData?.productCategory || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Brand
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Brand"
                        readOnly
                        name="productBrand"
                        value={currentData?.productBrand || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>
                </Stack>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    marginTop: "24px",
                  }}
                >
                  {currentData?.productImage?.length > 0 &&
                    currentData?.productImage?.map((item, index) => (
                      <Box>
                        <img
                          src={item}
                          alt={index}
                          width="80px"
                          height="80px"
                        />
                      </Box>
                    ))}
                </Box>
                <Stack direction="row" sx={{ marginTop: "20px" }} gap={2}>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Price (USD)
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Category"
                        readOnly
                        name="productCategory"
                        value={currentData?.productPrice || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Weight (lb)
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Brand"
                        readOnly
                        name="productBrand"
                        value={currentData?.productWeight || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Stock
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Brand"
                        readOnly
                        name="productBrand"
                        value={currentData?.productStock || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>
                </Stack>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    mr: 1,
                    marginTop: "20px",
                  }}
                >
                  Dimentions (cm)
                </Typography>
                <Stack direction="row" gap={2} sx={{ marginBottom: "20px" }}>
                  <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{ fontSize: "14px", fontWeight: "500", mr: 1 }}
                    >
                      L
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Category"
                        readOnly
                        name="productCategory"
                        value={currentData?.productPrice || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>

                  <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{ fontSize: "14px", fontWeight: "500", mr: 1 }}
                    >
                      W
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Brand"
                        readOnly
                        name="productBrand"
                        value={currentData?.productWeight || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>

                  <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{ fontSize: "14px", fontWeight: "500", mr: 1 }}
                    >
                      H
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }} size="small">
                      <OutlinedInput
                        type="text"
                        sx={{
                          height: "35px",
                          width: "100%",
                        }}
                        placeholder="Enter Brand"
                        readOnly
                        name="productBrand"
                        value={currentData?.productStock || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>
                </Stack>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Description
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                      <OutlinedInput
                        type="text"
                        sx={{
                          width: "100%",
                        }}
                        placeholder="Enter Name"
                        readOnly
                        multiline
                        rows={5}
                        name="productName"
                        value={currentData?.productDescription || ""}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    marginTop: "20px",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Tags
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {currentData?.productTags?.length > 0 &&
                        currentData?.productTags?.map((item, index) => (
                          <Typography
                            sx={{
                              backgroundColor: "rgba(238, 238, 238, 1)",
                              borderRadius: "16px",
                              padding: "5px 12px",
                              marginRight: 1,
                            }}
                          >
                            {item}
                          </Typography>
                        ))}
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "background: rgba(28, 38, 48, 1)",
                    }}
                  >
                    Variant Table
                  </Typography>
                  {varinatDatav1?.length > 0 ? (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Paper
                        sx={{
                          width: "100%",
                          borderRadius: "4px",
                          border: "1px solid #E5E5E8",
                        }}
                      >
                        <DataTableComponent
                          data={varinatDatav1}
                          columns={variantColumns}
                          customStyles={{
                            table: {
                              style: {
                                borderCollapse: "collapse",
                              },
                            },
                            headCells: {
                              style: {
                                borderRight: "1px solid rgba(229, 229, 232, 1)",
                              },
                            },
                            cells: {
                              style: {
                                borderRight: "1px solid rgba(229, 229, 232, 1)",
                              },
                            },
                          }}
                        />
                      </Paper>
                    </Box>
                  ) : varinatDatav2?.length > 0 ? (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Paper
                        sx={{
                          width: "100%",
                          border: "1px solid #E5E5E8",
                          borderRadius: "4px",
                        }}
                      >
                        <DataTableComponent
                          data={varinatDatav2}
                          columns={variantColumns}
                          customStyles={{
                            table: {
                              style: {
                                borderCollapse: "collapse",
                              },
                            },
                            headCells: {
                              style: {
                                borderRight: "1px solid rgba(229, 229, 232, 1)",
                              },
                            },
                            cells: {
                              style: {
                                borderRight: "1px solid rgba(229, 229, 232, 1)",
                              },
                            },
                          }}
                        />
                      </Paper>
                    </Box>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
            </SimpleBar>
          </Box>
          <Box sx={{ paddingRight: "20px", marginTop: "15px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "153px",
                  backgroundColor: "rgba(45, 197, 140, 1)",
                  color: "#FFF",
                  marginLeft: "10px",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                  boxShadow: "none",
                  "&:hover": {
                    outline: "none",
                    color: "#FFF",
                    backgroundColor: "rgba(45, 197, 140, 1)", // Remove border color on focus
                  },
                }}
                onClick={() => {
                  if (value === 1) {
                    handleRightForNew(currentData);
                    setCurrentData();
                    setUnderReviewDrawer(false);
                  } else {
                    handleRightForUpdate(currentData);
                    setCurrentData();
                    setUnderReviewDrawer(false);
                  }
                }}
              >
                <img src={right} alt="star" style={{ marginRight: "10px" }} />
                Approve
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: "153px",
                  backgroundColor: "rgba(235, 87, 87, 1)",
                  color: "#FFF",
                  marginLeft: "10px",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                  boxShadow: "none",
                  "&:hover": {
                    outline: "none",
                    color: "#FFF",
                    backgroundColor: "rgba(235, 87, 87, 1)", // Remove border color on focus
                  },
                }}
                onClick={() => {
                  setConfirmationModalState((prev) => ({
                    showModal: true,
                    productId: currentData?.productId,
                  }));
                }}
              >
                <img src={cancel} alt="star" style={{ marginRight: "10px" }} />
                Decline
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
      <ConfirmationModal
        showModal={confirmatioModalState.showModal}
        submitHandler={() => deleteHandler()}
        submitText={"Decline"}
        cancelText={"Cancel"}
        cancelHandler={cancelHandler}
        headerText={"Add note to seller so they know why it's declined"}
        bodyText={
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <OutlinedInput
              type="text"
              sx={{
                width: "100%",
                backgroundColor: "rgba(249, 250, 252, 1)",
              }}
              placeholder="note"
              multiline
              rows={2}
              name="note"
              autoComplete="off"
            />
          </Box>
        }
      />
    </>
  );
}
